import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import authSlice from "./Slice/Auth/AuthSlice";
import loaderReducer from "./Slice/Loader/loaderSlice";
const rootReducer = combineReducers({
  auth: authSlice,
  loader: loaderReducer,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["loader"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
